import { checkAndUpdateToken } from "./auth";

import { BACKEND_URL_PREFIX, itemsOnPage } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import {
  CURRENT_PERFORMANCE_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
  TASKS_FETCH_COMPLETED,
  IND_RESULT_FILES_FETCH_COMPLETED,
  GROUP_RESULT_FILES_FETCH_COMPLETED,
  STUDENT_PROJECTS_FETCH_COMPLETED,
  STUDENT_PROJECT_FETCH_COMPLETED,
  STUDENTS_FETCH_COMPLETED,
  CURRENT_PERFORMANCE_FETCH_STARTED,
  CURRENT_PERFORMANCE_LOADING_OFF,
  SET_STUDENTS_PAGES_COUNT,
} from "./types";

export const types = {
  INDIVIDUAL_TYPE: "user",
  GROUP_TYPE: "group",
};

export const typesOfWork = {
  HOME_WORK_IND: "ind",
  RESULT_WORK_IND: "resultInd",
  HOME_WORK_GROUP: 'hwgroup',
  RESULT_WORK_GROUP: 'resultGroup'

};

export const currentPerformances = (cId, termId) => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: CURRENT_PERFORMANCE_FETCH_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/journal/student/homework/info/${termId}/${cId}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: CURRENT_PERFORMANCE_FETCH_COMPLETED, data: result });
    }
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: CURRENT_PERFORMANCE_LOADING_OFF })
  }
};

export const studentProjects = (cId, termId, isTeacher, studentId, groupId) => async (
  dispatch,
  getState
) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const { mid } = getState().auth;
    const url = isTeacher
      ? `${BACKEND_URL_PREFIX}/student_project/teacher/${termId}/${cId}/${studentId}/${groupId}`
      : `${BACKEND_URL_PREFIX}/student_project/${termId}/${cId}`;

    const response = await fetch(`${url}`, buildDefaultHeaders(getState));

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: STUDENT_PROJECTS_FETCH_COMPLETED, data: result });
    } else {
      console.log("Error -", response);
    }
  }
};

export const studentProject = (projectId) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/${projectId}`,
    buildDefaultHeaders(getState)
  );
  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const result = await response.json();
    dispatch({
      type: STUDENT_PROJECT_FETCH_COMPLETED,
      data: { ...result, xp_key: projectId },
    });
  }
};

// Номер последнего отправленного запроса списка обучающихся: при быстрых
// повторных изменениях условий отбора в список попадает результат последнего
// запроса, а не тот, чей ответ пришёл последним
let studentsRequestId = 0;

export const students = (pageNumber, findStudent, findFaculty, findKurs, findGroup, selectedStatus, year, cathedra) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  dispatch({ type: CURRENT_PERFORMANCE_FETCH_STARTED });
  if (getState().auth.token) {
    if (pageNumber === 'teacher') {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/users/students`,
        buildDefaultHeaders(getState)
      );
      dispatch({ type: NETWORK_REQUEST_SENT, response });
      if (response.ok) {
        const result = await response.json();
        dispatch({ type: STUDENTS_FETCH_COMPLETED, data: result });
      } else {
        console.log("fetchPermanentStaff failed")
      }

    }

    else {
      let params = {}
      if (typeof (pageNumber) === 'number') {
        params = {
          paginateFrom: itemsOnPage * pageNumber,
          maxResults: itemsOnPage,
        }
      }
      // Number(groupId) && (params.group = groupId)
      findFaculty !== 'all' && (params.faculty = findFaculty)
      findKurs !== 'all' && (params.kurs = findKurs)
      findGroup !== 'all' && (params.group = findGroup)
      selectedStatus && (params.status = selectedStatus)
      year && (params.year = year)
      cathedra && (params.cathedra = cathedra)
      // поиск по ФИО — параметром `search` того же метода, а не отдельным
      // роутом /users/students/<name>: только так вместе со страницей приходит
      // заголовок X-Total-Count с общим количеством найденных записей
      findStudent && (params.search = findStudent)

      studentsRequestId += 1;
      const requestId = studentsRequestId;

      const urlParams = new URLSearchParams(params).toString();
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/users/students?${urlParams}`,
        buildDefaultHeaders(getState)
      );
      dispatch({ type: NETWORK_REQUEST_SENT, response });
      // ответ на условия отбора, которые пользователь уже сменил, отбрасывается
      if (requestId !== studentsRequestId) return;
      if (response.ok) {
        const total = Number(response.headers.get('X-Total-Count'));
        const result = await response.json();
        dispatch({ type: STUDENTS_FETCH_COMPLETED, data: result });
        if (Number.isFinite(total) && response.headers.get('X-Total-Count') !== null) {
          dispatch({
            type: SET_STUDENTS_PAGES_COUNT,
            payload: { pagesCount: Math.ceil(total / itemsOnPage), totalCount: total },
          });
        } else {
          // заголовок не дошёл (старый сервер либо он не отдан браузеру) —
          // количество считается прежним отдельным запросом с count=true
          dispatch(fetchStudentsCount(findStudent, findFaculty, findKurs, findGroup, selectedStatus, year, cathedra))
        }
      } else {
        console.log("fetchPermanentStaff failed")
      }
    }
  }
};

export const fetchStudentsCount = (findStudent, findFaculty, findKurs, findGroup, selectedStatus, year, cathedra) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    // const params = await fetch(
    //   `${BACKEND_URL_PREFIX}/users/students?count=true`,
    //   buildDefaultHeaders(getState)
    // );
    const params = { count: true }
    findFaculty !== 'all' && (params.faculty = findFaculty)
    findKurs !== 'all' && (params.kurs = findKurs)
    findGroup !== 'all' && (params.group = findGroup)
    selectedStatus && (params.status = selectedStatus)
    year && (params.year = year)
    cathedra && (params.cathedra = cathedra)
    findStudent && (params.search = findStudent)
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/users/students?${urlParams}`,
      buildDefaultHeaders(getState)
    );

    if (response.ok) {
      const data = await response.json();
      const count = Number(data?.[0]?.count) || 0
      const payload = { pagesCount: Math.ceil(count / itemsOnPage), totalCount: count };
      await dispatch({ type: SET_STUDENTS_PAGES_COUNT, payload });
    } else {
      console.log("fetchStudentsCount failed")
    }
  }
};

export const downloadFile = (
  filename,
  sheId,
  instance,
  type
) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/journal${type === 'user' ? '/student' : ''}/homework/fact/${sheId}/${instance}/${filename}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.blob();
    const fileDownload = require("js-file-download");
    fileDownload(data, filename);
  }
};

export const downloadStudentFile = (filename, type, projectId) => async (
  dispatch,
  getState
) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/${type}/${projectId}/${filename}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.blob();
    const fileDownload = require("js-file-download");
    fileDownload(data, filename);
  }
};

export const files = (
  sheId,
  instance,
  type,
  typeOfWork = typesOfWork.HOME_WORK
) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/journal${type === 'user' ? '/student' : ''}/homework/fact/${sheId}/${instance}`,
    buildDefaultHeaders(getState)
  );
  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const result = await response.json();
    dispatch({ type: TASKS_FETCH_COMPLETED, data: result });
  }
};
export const studentResultFiles = (
  sheId,
  instance,
  userId,
) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/homework/userresult/${userId}/${sheId}/${instance}`,
    buildDefaultHeaders(getState)
  );
  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const result = await response.json();
    dispatch({ type: TASKS_FETCH_COMPLETED, data: result }); // FILES  для индив задания
    // dispatch({ type: IND_RESULT_FILES_FETCH_COMPLETED, data: result }); // FILES  для индив задания
  }
};
export const fetchGroupStudentsFiles = (
  sheId,
  instance,
  userId,
  type,
) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/homework/groupresult/${userId}/${sheId}/${instance}`,
    buildDefaultHeaders(getState)
  );
  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const result = await response.json();
    dispatch({ type: TASKS_FETCH_COMPLETED, data: result }); // FILES  для групп задания
    // dispatch({ type: GROUP_RESULT_FILES_FETCH_COMPLETED, data: result }); // FILES  для групп задания
  }
};

export const uploadFile = (file, sheId, instance, type, typeOfWork, userId) => async (
  dispatch,
  getState
) => {

  const { token, mid } = getState().auth;
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/homework/${type}${typeOfWork}/${mid}/${sheId}/${instance}`,
    {
      method: "POST",
      body: formData,
      headers: {
        "Access-Control-Allow-Origin": "*",
        // 'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${btoa(`${token}:empty`)}`,
      },
    }
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const data = await response.json();
    const { success } = data;
    success && dispatch(files(sheId, instance, type, typeOfWork));
    success && dispatch(fetchGroupStudentsFiles(sheId, instance, userId, typeOfWork));
  }
};

export const uploadStudentReviewFile = (projectId, reviewId, file) => async (
  dispatch,
  getState
) => {
  const { token } = getState().auth;
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/review/${reviewId}`,
    {
      method: "POST",
      body: formData,
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${token}:empty`)}`,
      },
    }
  );

  if (response.ok) {
    const data = await response.json();
    const { success } = data;
    success && dispatch(studentProject(projectId));
  }
};

export const uploadStudentFile = (file, type, projectId) => async (
  dispatch,
  getState
) => {

  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const { token } = getState().auth;
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/student_project/${type}/${projectId}`, // 4495
      // `${BACKEND_URL_PREFIX}/student_project/task/${projectId}`,
      {
        method: "POST",
        body: formData,
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Basic ${btoa(`${token}:empty`)}`,
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      const { success } = data;
      success && dispatch(studentProject(projectId));
    }
  }
};

export const updateStudentWork = (projectId, values) => async (
  dispatch,
  getState
) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/${projectId}`,
    {
      method: "PUT",
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    }
  );

  if (response.ok) {
    const data = await response.json();
    const { success } = data;
    success && dispatch(studentProject(projectId));
  }
};

export const deleteFile = (
  filename,
  sheId,
  instance,
  type,
  typeOfWork,
  userId,
) => async (dispatch, getState) => {
  const { token, mid } = getState().auth;
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/homework/${type}${typeOfWork}/${mid}/${sheId}/${instance}/${filename}`,
    {
      method: "DELETE",
      headers: {
        "Access-Control-Allow-Origin": "*",
        // 'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${btoa(`${token}:empty`)}`,
      },
    }
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const data = await response.json();
    const { success } = data;
    success && dispatch(files(sheId, instance, type, typeOfWork));
  }
};

export const deleteStudentFile = (projectId, type, name) => async (
  dispatch,
  getState
) => {
  const { token } = getState().auth;
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/${type}/${projectId}/${name}`,
    {
      method: "DELETE",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${token}:empty`)}`,
      },
    }
  );

  if (response.ok) {
    const data = await response.json();
    const { success } = data;
    success && dispatch(studentProject(projectId));
  }
};

export const addReview = (projectId, values, files) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/projectreview/${projectId}`,
    {
      method: "POST",
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    }
  );

  if (response.ok) {
    const data = await response.json();
    data && dispatch(studentProject(projectId));
    if (data && files && files.length) {
      dispatch(uploadStudentReviewFile(projectId, data, files[0]));
    } else if (data && values && values.reviewFile) {
      dispatch(uploadStudentReviewFile(projectId, data, values.reviewFile[0]));
    }
  }
};

export const removeReview = (projectId, reviewId) => async (
  dispatch,
  getState
) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/projectreview/${reviewId}`,
    {
      method: "DELETE",
      ...buildDefaultHeaders(getState),
    }
  );

  if (response.ok) {
    const data = await response.json();
    data && dispatch(studentProject(projectId));
  }
};

export const editReview = (projectId, reviewId, values) => async (
  dispatch,
  getState
) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/projectreview/${reviewId}`,
    {
      method: "PUT",
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    }
  );

  if (response.ok) {
    const data = await response.json();
    data && dispatch(studentProject(projectId));
  }
};

export const removeReviewFile = (projectId, reviewId, name) => async (
  dispatch,
  getState
) => {
  const { token } = getState().auth;
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/student_project/review/${reviewId}/${name}`,
    {
      method: "DELETE",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${token}:empty`)}`,
      },
    }
  );

  if (response.ok) {
    const data = await response.json();
    const { success } = data;
    success && dispatch(studentProject(projectId));
  }
};

export const addProject = (values, files) => async (dispatch, getState) => {
  const response = await fetch(`${BACKEND_URL_PREFIX}/student_project`, {
    method: "POST",
    body: JSON.stringify(values),
    ...buildDefaultHeaders(getState),
  });

  if (response.ok) {
    const data = await response.json();

    if (data) {
      const { cid, termId, student, groupId } = values;
      dispatch(studentProjects(cid, termId, true, student, groupId));
      if (files.length) {
        files.forEach(file => dispatch(uploadStudentFile(file, "task", data)))
      }
    }
  } else {
    console.log("Error - ", response);
  }
};

export const clearProject = () => (dispatch) => {
  dispatch({ type: STUDENT_PROJECT_FETCH_COMPLETED, data: {} });
};
